const ACCENT_FROM = "àáâéèêëíìîïóòôõúùû";
const ACCENT_TO = "aaaeeeeiiiioooouuu";

/**
 * Dieselbe Faltung wie private_helpers.fold_search:
 * ä/ae → a, ö/oe → o, ü/ue → u, ß → ss.
 */
export function foldSearch(value: string | null | undefined): string {
  const expanded = (value ?? "")
    .trim()
    .replaceAll("Ä", "ä")
    .replaceAll("Ö", "ö")
    .replaceAll("Ü", "ü")
    .toLowerCase()
    .replaceAll("ß", "ss")
    .replaceAll("ä", "ae")
    .replaceAll("ö", "oe")
    .replaceAll("ü", "ue")
    .replaceAll("ae", "a")
    .replaceAll("oe", "o")
    .replaceAll("ue", "u");
  return [...expanded]
    .map((ch) => {
      const index = ACCENT_FROM.indexOf(ch);
      return index >= 0 ? ACCENT_TO[index]! : ch;
    })
    .join("");
}

/** Teiltreffer auf beiden Seiten nach derselben Faltung. Leere Suche trifft alles. */
export function foldedIncludes(haystack: string, needle: string): boolean {
  const query = foldSearch(needle);
  if (query.length === 0) return true;
  return foldSearch(haystack).includes(query);
}
